import { Text, } from '@spotify-internal/encore-web';
import React from 'react';
import styled from 'styled-components';
export const Wrapper = styled.div `
  display: -webkit-box;
  -webkit-line-clamp: ${({ lines }) => lines};
  -webkit-box-orient: vertical;
  overflow: hidden;
  hyphens: auto;
  text-overflow: ellipsis;
`;
export const TruncatedText = ({ children, lines, semanticColor, variant, }) => {
    return (React.createElement(Text, { semanticColor: semanticColor, variant: variant },
        React.createElement(Wrapper, { lines: lines }, children)));
};
